import { LineitemStatus } from "model/lineitems";

// Archived is not a run state - a lineitem is archived independently of how it
// was running, and once it is the run state says nothing useful.
export enum LineitemViewStatus {
  Archived = "archived",
}

export const LINEITEM_STATUS_DISPLAY = {
  [LineitemStatus.Running]: {
    tooltip: "Lineitem is running",
    label: "Running",
  },
  [LineitemStatus.AutoPaused]: {
    tooltip: "Optimiser has temporarily paused this line item",
    label: "Auto-Paused",
  },
  [LineitemStatus.Paused]: { tooltip: "Lineitem is paused", label: "Paused" },
  [LineitemStatus.Finished]: {
    tooltip: "Lineitem is finished",
    label: "Finished",
  },
  [LineitemViewStatus.Archived]: {
    tooltip: "Lineitem is archived",
    label: "Archived",
  },
};
